import ttt from './initializedTtt';
import { defaultProps } from 'recompose';

const withActionTracker = defaultProps({
  track: (action, contextData = {}) => {
    ttt.event('PropTrackAction', { PropTrackAction: action, ...contextData });
  },
});

export default withActionTracker;
